"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rugbyUnionConfig = {
    clock: {
        direction: 'up',
        endPeriodType: 'tickUntilEnd',
        cumulative: true
    }
};
//# sourceMappingURL=sportConfig.js.map